<template>
  <performer-projects-layout @scroll-bottom="handleScrolledToBottom">
    <template #default>
      <main-title>Мои проекты</main-title>
      <horizontal-filter>
        <template #default>
          <filter-item hash="#inwork" text="В работе" />
          <filter-item hash="#archive" text="Архив" />
        </template>
        <template #right>
          <label class="panel__total-requests"> Всего: {{ totalItems }} </label>
        </template>
      </horizontal-filter>
      <projects-filter
        :status-list="statusList"
        @update-filter="updateFilter"
      />
      <infinite-grid-layout
        :get-items="api.project.projectStats"
        :url-params="urlParams"
        :scroll-bottom="scrollBottom"
        entity="projects"
        @update-total-count="handleUpdateTotalCount"
      >
        <template #table-item="slotProps">
          <project-card :project="slotProps.item" />
        </template>
      </infinite-grid-layout>
    </template>
  </performer-projects-layout>
</template>

<script setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import { useApi } from '@/api/use-api';
  import PerformerProjectsLayout from './layouts/PerformerProjectsLayout.vue';
  import MainTitle from '@/components/titles/MainTitle';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter';
  import FilterItem from '@/components/filter/components/FilterItem';
  import { useRoute } from 'vue-router';
  import ProjectCard from '@/views/performer/components/ProjectCard.vue';
  import {
    PROJECT_TAB_ARCHIVE,
    PROJECT_TAB_IN_WORK,
  } from '@/constants/project-tab';
  import {
    PROJECT_STATUS_NAME_ACCEPTANCE,
    PROJECT_STATUS_NAME_AGREEMENT,
    PROJECT_STATUS_NAME_CLOSED,
    PROJECT_STATUS_NAME_DRAFT,
    PROJECT_STATUS_NAME_IN_WORK,
    PROJECT_STATUS_NAME_REJECTED,
  } from '@/constants/project-status';
  import ProjectsFilter from '@/components/projects/components/ProjectsFilter.vue';
  import InfiniteGridLayout from '@/components/infinite-grid/InfiniteGridLayout.vue';

  const api = useApi();
  const route = useRoute();
  const totalItems = ref(0);
  const scrollBottom = ref(0);
  const urlParams = ref(null);

  const statusList = computed(() => {
    const tab = route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK;
    switch (tab) {
      case PROJECT_TAB_IN_WORK:
        return [
          PROJECT_STATUS_NAME_DRAFT,
          PROJECT_STATUS_NAME_IN_WORK,
          PROJECT_STATUS_NAME_AGREEMENT,
          PROJECT_STATUS_NAME_ACCEPTANCE,
        ];
      case PROJECT_TAB_ARCHIVE:
        return [PROJECT_STATUS_NAME_CLOSED, PROJECT_STATUS_NAME_REJECTED];
      default:
        return [];
    }
  });

  onMounted(() => {
    urlParams.value = new URLSearchParams({
      tab: route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK,
      role: route.meta.role,
    });
    if (route.query.textSearch) {
      urlParams.value.set('textSearch', route.query.textSearch);
    }
  });

  watch(
    () => route.hash,
    async () => {
      updateFilter(new URLSearchParams([...urlParams.value]));
    }
  );

  const updateFilter = (filterParams) => {
    filterParams.set(
      'tab',
      route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK
    );
    urlParams.value = filterParams;
  };

  const handleScrolledToBottom = (value) => {
    scrollBottom.value = value;
  };

  const handleUpdateTotalCount = (value) => {
    totalItems.value = value;
  };
</script>

<style lang="scss" scoped></style>
